import React from 'react';

const CourseSchedule = ({ courseDetails, selectedDate }) => {
  const getStatusColor = (status) => {
    const colors = {
      'completed': 'bg-green-100 text-green-800',
      'scheduled': 'bg-blue-100 text-blue-800',
      'pending': 'bg-yellow-100 text-yellow-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const getStatusText = (status) => {
    const texts = {
      'completed': '已完成',
      'scheduled': '已安排',
      'pending': '待記錄'
    };
    return texts[status] || '未知狀態';
  };

  const timeSlots = [
    '8:10-8:45', '8:45-9:20', '9:20-9:55', '10:15-10:50', 
    '10:50-11:25', '11:30-12:05', '12:05-12:40', '1:50-2:25', 
    '2:25-3:00', '3:00-3:35'
  ];

  return (
    <div className="course-schedule">
      <div className="schedule-header">
        <h3>當日課程安排</h3>
        <p>顯示選定日期的完整課程安排</p>
      </div>

      {courseDetails.length === 0 ? (
        <div className="empty-schedule">
          <div className="empty-icon">📚</div>
          <h4>當日無課程安排</h4>
          <p>選定的日期沒有安排課程</p>
        </div>
      ) : (
        <div className="schedule-list">
          {courseDetails.map((course, index) => (
            <div key={course.id} className="course-item">
              <div className="course-time">
                <div className="time-slot">
                  {timeSlots[course.time_slot - 1]}
                </div>
                <div className="time-number">
                  第{course.time_slot}節
                </div>
              </div>

              <div className="course-content">
                <div className="course-header">
                  <h4 className="course-title">{course.course_title}</h4>
                  <span className={`status-badge ${getStatusColor(course.completion_status)}`}>
                    {getStatusText(course.completion_status)}
                  </span>
                </div>

                <div className="course-details">
                  <div className="detail-row">
                    <span className="detail-label">科目:</span>
                    <span className="detail-value">{course.subject}</span>
                  </div>
                  
                  <div className="detail-row">
                    <span className="detail-label">課室:</span>
                    <span className="detail-value">📍 {course.classroom}</span>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">課程內容:</span>
                    <span className="detail-value">{course.course_content}</span>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">學習目標:</span>
                    <span className="detail-value">{course.learning_objectives}</span>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">教學材料:</span>
                    <span className="detail-value">{course.teaching_materials}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="schedule-summary">
        <div className="summary-stats">
          <div className="stat-item">
            <span className="stat-number">{courseDetails.length}</span>
            <span className="stat-label">總課程數</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">
              {courseDetails.filter(c => c.completion_status === 'completed').length}
            </span>
            <span className="stat-label">已完成</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">
              {courseDetails.filter(c => c.completion_status === 'scheduled').length}
            </span>
            <span className="stat-label">已安排</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseSchedule;
